import { render, staticRenderFns } from "./LocalTotalCounts.vue?vue&type=template&id=67ec6bbb&"
import script from "./LocalTotalCounts.vue?vue&type=script&lang=js&"
export * from "./LocalTotalCounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports